<template>
    <router-view></router-view>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "app",
  created() {
    this.getUserAgentInfo();
  },
  methods: {
    ...mapActions('uaParser', ['getUserAgentInfo'])
  }
}
</script>
